module.exports = __webpack_public_path__ + "angular-feature.ezY0DJkc.svg";